import { gql } from '@apollo/client'
import { IS_VERBOSE } from 'config/development'
import { getSyntheticsGraphClient } from 'rfx/lib/subgraph'
import { useChainId } from 'rfx/lib/chains'
import useSWR from 'swr'
import { sub } from 'date-fns'
import commonPoolStore from '@store/commonPoolStore'

export const useCommonPoolAPR = () => {
  const { chainId } = useChainId()
  const client = getSyntheticsGraphClient(chainId)
  const selectedVault = commonPoolStore((store) => store.selectedVault)
  const { data } = useSWR(`common-pool-apr-${selectedVault.value}-${chainId}`, {
    fetcher: async () => {
      try {
        const query = gql(`
            {
              sharePrices_recent: sharePrices(
                orderBy: timestamp
                orderDirection: desc
                first: 1
                where: { commonPool: "${selectedVault?.value.toLowerCase()}"}
              ) {
                  price
                  timestamp
              }
              
            sharePrices_lte_start_of_period: sharePrices(
                orderBy:timestamp
                orderDirection:desc
                where: {
                commonPool: "${selectedVault?.value.toLowerCase()}"
                  timestamp_lte:${Math.floor(
                    sub(new Date(), { days: 1 }).valueOf() / 1000,
                  )}
                },
                first: 1
            ) {
                price
                timestamp
            }
            
        }`)
        const { data } = await client!.query({ query, fetchPolicy: 'no-cache' })
        const v1 =
          Number(data.sharePrices_lte_start_of_period[0]?.price || 0) *
          Math.pow(10, -18)
        const v2 =
          Number(data.sharePrices_recent[0]?.price || 0) * Math.pow(10, -18)

        const t2 = data.sharePrices_recent[0]?.timestamp
        const t1 = data.sharePrices_lte_start_of_period[0]?.timestamp

        if (!v1 || !v2) {
          return { apr: 0, lastRebalance: 0 }
        }

        const apr = ((v2 - v1) / v1) * 100 * ((365 * 24 * 60 * 60) / (t2 - t1))
        return { apr, lastRebalance: t2 }
      } catch (err) {
        // eslint-disable-next-line no-console
        IS_VERBOSE && console.log('🚀 ~ fetcher: ~ err:', err)
        return { apr: 0, lastRebalance: 0 }
      }
    },
  })

  return { apr: data?.apr, lastRebalance: data?.lastRebalance || 0 }
}
